import React from 'react';
import { ClosingPriceExplorer } from '@components';

const ClosingPrice = () => {
    return (
        <ClosingPriceExplorer
            title="THE Closing Prices"
            description="Browse folders and download CSV files"
            rootPath="/media/files/csv/closing/the/"
            breadcrumbRootLabel="the-closing"
            searchPlaceholders={{
                0: 'Search year folder (e.g. 2026)',
                1: 'Search month folder (e.g. 03 or March)',
                2: 'Search filename (e.g. 01.03.2026.csv)',
                default: 'Search filename or date'
            }}
            levelLabels={{
                0: 'Year',
                1: 'Month',
                2: 'Day',
                default: 'Folder'
            }}
        />
    );
};

export default ClosingPrice;
